import React from "react";
import { FormatMoney } from "../../../Helpers/FormatNumber";
import { GetParetoAcumulado } from "../../../Helpers/Pareto";

// Tabla de Pareto (80/20) reutilizable: `datos` con { nombre, valor },
// muestra ranking con % y % acumulado; el "vital few" (80%) se resalta.
// `metrica` solo cambia el encabezado/formato de la columna de valor.
export const TablaPareto = ({
    datos = [],
    titulo = "Pareto",
    columnaNombre = "Cliente",
    onRowClick,
    metrica = "monto",
}) => {
    const filas = GetParetoAcumulado(datos, "valor");
    const formatearValor = (valor) =>
        metrica === "cantidad" ? `${Math.round(valor).toLocaleString("es-MX")} unidades` : `$${FormatMoney(valor, 0)}`;

    return (
        <div className="tabla-pareto">
            <div className="tabla-pareto-titulo">{titulo}</div>
            <div className="tabla-pareto-header">
                <span>#</span>
                <span>{columnaNombre}</span>
                <span>{metrica === "cantidad" ? "Cantidad" : "Venta"}</span>
                <span>%</span>
                <span>% Acum.</span>
            </div>
            <div className="tabla-pareto-body scroll">
                {filas.map((fila, index) => (
                    <div
                        key={`pareto-${index}`}
                        className={`tabla-pareto-row${fila.esClave ? " tabla-pareto-row--clave" : ""
                            }${typeof onRowClick === "function" ? " tabla-pareto-row--clickable" : ""
                            }`}
                        onClick={() => onRowClick && onRowClick(fila)}
                    >
                        <span>{index + 1}</span>
                        <span title={fila.nombre}>{fila.nombre}</span>
                        <span>{formatearValor(fila.valor)}</span>
                        <span>{fila.porcentaje.toFixed(1)}%</span>
                        <span>{fila.porcentajeAcumulado.toFixed(1)}%</span>
                    </div>
                ))}
            </div>
        </div>
    );
};
